import { useNavigate } from 'react-router-dom';
import { Video, ChevronRight } from 'lucide-react';
import { Button } from '../ui/button';
import CommentSection from '../CommentSection';
import LikeButton from '../LikeButton';
import FireButton from '../FireButton';

const getEmbedUrl = (url) => {
  if (!url) return '';
  const ytMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([a-zA-Z0-9_-]+)/);
  if (ytMatch) return `https://www.youtube.com/embed/${ytMatch[1]}`;
  const vimeoMatch = url.match(/vimeo\.com\/(\d+)/);
  if (vimeoMatch) return `https://player.vimeo.com/video/${vimeoMatch[1]}`;
  return url;
};

export function VideosSection({ videos, siteSettings, isVisible }) {
  const navigate = useNavigate();
  if (!isVisible('videos') || videos.length === 0) return null;

  const featured = videos.find(v => v.is_featured) || videos[0];

  return (
    <section className="border-t border-[#262626] py-16 sm:py-24 px-4 sm:px-8" data-testid="videos-section" id="videos">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-12">
          <div>
            <p className="overline text-[var(--primary,#FF3B30)] mb-2">{siteSettings?.section_titles?.videos_label || 'WATCH'}</p>
            <h2 className="font-cabinet text-3xl sm:text-4xl font-black uppercase tracking-tighter">
              {siteSettings?.section_titles?.videos || 'VISUALS'}
            </h2>
          </div>
          <Video className="w-8 h-8 text-[var(--primary,#FF3B30)]" />
        </div>

        <div>
          <div className="border border-[#262626] overflow-hidden" data-testid="featured-video">
            <div className="aspect-video bg-black">
              <iframe
                src={getEmbedUrl(featured.url)}
                title={featured.title}
                className="w-full h-full"
                allowFullScreen
                loading="lazy"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              />
            </div>
            <div className="p-5 bg-[#141414]">
              <h3 className="font-cabinet font-bold text-xl uppercase">{featured.title}</h3>
              {featured.description && <p className="text-[#A3A3A3] text-sm mt-1">{featured.description}</p>}
              <div className="flex items-center gap-5 mt-4">
                <LikeButton itemType="video" itemId={featured.id} size="md" />
                <FireButton itemType="video" itemId={featured.id} size="md" />
              </div>
              <CommentSection itemType="video" itemId={featured.id} />
            </div>
          </div>

          {videos.length > 1 && (
            <div className="mt-6 text-center">
              <Button
                onClick={() => navigate('/videos')}
                variant="outline"
                className="rounded-none border-[var(--primary,#FF3B30)] text-[var(--primary,#FF3B30)] hover:bg-[var(--primary,#FF3B30)] hover:text-white px-8 py-3 font-bold uppercase tracking-wider"
                data-testid="more-visuals-btn"
              >
                <Video className="w-4 h-4 mr-2" />
                MORE VISUALS
                <ChevronRight className="w-4 h-4 ml-2" />
              </Button>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
